
import { Box, Center, Flex, Switch, Text } from "@chakra-ui/react";
import { TouchEvent, useState } from "react";

import { $isfunction } from "foundation-ts/commons";
import { userName } from "doxecure-commons/lib/doxecureFunctions";

import { UserCardProps } from "@components/Cards/UserCard";
import { CardDescription } from "@components/Cards/CardDescription";
import { G1Icon } from "@utils/icons";
import { localtrans } from "@utils/LocalTranslations";

interface SignerCardProps extends UserCardProps {
    qualifiedSwitch?: boolean;
    draggable: boolean;
    onQualifiedSwitchChange?: (checked: boolean) => void;
    onDragStart?: () => void;
    onDragEnd?: () => void;
    onTouchStart?: (e: TouchEvent) => void;
    onTouchMove?: (e: TouchEvent) => void;
    onTouchEnd?: () => void;
}

export const SignerCard = (props: SignerCardProps) => {
    const {
        itemStyle,
        item,
        qualifiedSwitch = false,
        draggable = true,
        onRemoveItemClick,
        onQualifiedSwitchChange,
        onDragStart,
        onDragEnd,
        onTouchStart,
        onTouchMove,
        onTouchEnd,
        ...rest
    } = props ;
    const [qualifiedSwitchChecked, setQualifiedSwitchChecked] = useState(qualifiedSwitch);

    return (
        <Box position="relative" width='100%'>
            <Box position='absolute' right="3" top="3" zIndex="2">
                <Center>
                    <Switch size='sm' colorScheme="green" isChecked={qualifiedSwitchChecked} pr={1} onChange={(event) => {
                        setQualifiedSwitchChecked(event.target.checked);
                        onQualifiedSwitchChange?.(event.target.checked);
                    }} />
                    <Text fontSize="12px" color={qualifiedSwitchChecked ? 'whiteAlpha.600' : 'whiteAlpha.300'}>&nbsp;{localtrans('QSCDSignature')}</Text>
                </Center>
            </Box>
            <Flex
                p={2}
                width="100%"
                minH="6em"
                borderTop={itemStyle.borderTop ?? "1px"}
                borderTopColor={itemStyle.borderTopColor ?? "inherit"}
                draggable={draggable}
                transition="all 0.2s"
                style={{ touchAction: 'none' }}
                cursor={draggable ? "grab" : "auto"}
                _hover={draggable ? itemStyle.hover : undefined}
                _focus={itemStyle.select}
                _active={{ cursor: draggable ? 'grabbing' : 'auto' }}
                onDragStart={onDragStart}
                onDragEnd={onDragEnd}
                onTouchStart={onTouchStart}
                onTouchMove={onTouchMove}
                onTouchEnd={onTouchEnd}
                {...rest}
            >
                <CardDescription title={`${userName(item)}`} moreInfos={`${item.email}`} width="100%" />
                <Box alignSelf="center" width="20%" display="flex" justifyContent="flex-end" cursor="pointer">
                    <Box margin="5%" alignSelf="center" color={itemStyle.iconColor ?? "inherit"}>
                        { $isfunction(onRemoveItemClick) ? <G1Icon.Minus size="20px" cursor="pointer" onClick={onRemoveItemClick} /> : <G1Icon.View size="20px" cursor="pointer" /> }
                    </Box>
                </Box>
            </Flex>
        </Box>
    ) ;
}